import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { formatVehicleComment } from "../../../shared/lib/format/vehicle/formatVehicleComment.js";
import "../../../shared/lib/logger/index.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { title, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const vehicleItem = useThisContext();
  const children = useMemo(() => vehicleItem ? formatVehicleComment(vehicleItem) : null, [vehicleItem]);
  return {
    title: title ?? t("widgets.dealerComment.title"),
    children,
    ...props
  };
};
export {
  useContainer
};
